// extracted by mini-css-extract-plugin
export default {"art":"style_art__eFgtb","artImg":"style_artImg__4mA4d","artPh":"style_artPh__x64L5"};